const proverbs = new Map([
	['Actions speak louder than words', '🚶‍♀️>🗣️'],
	['A penny saved is a penny earned', '💰➡️🏦=💰➡️💼'],
	["All's well that ends well", '😊⏩😊⏹️'],
	['An apple a day keeps the doctor away', '🍎📅=👨‍⚕️❌'],
	['Better safe than sorry', '🛡️>😢'],
	['Curiosity killed the cat', '😺+❓=☠️'],
	["Don't judge a book by its cover", '📖👀❌=📔'],
	["Don't put all your eggs in one basket", '🥚🙅‍♂️🧺=🥚'],
	['Early bird catches the worm', '🐦🌞👀🐛'],
	['Fortune favors the bold', '💪=🍀👍'],
	['Good things come to those who wait', '⌛=🎁'],
	['Honesty is the best policy', '🗣️👍=🎖️'],
	["If at first you don't succeed, try, try again", '👎❌=🔄👍'],
	["It's never too late to learn", '📚+⌛=👍'],
	['Laughter is the best medicine', '😂=💊'],
	['Practice makes perfect', '🔄🏋️‍♂️=💯'],
	['The early bird catches the worm', '🐦🌞👀🐛'],
	['The grass is always greener on the other side', '🏞️👀➡️🏞️💚'],
	['When in Rome, do as the Romans do', '🏟️=👫🔄'],
	["Where there's smoke, there's fire", '💨=🔥'],
]);

export default proverbs;
